export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "separatorSize",
          name: t('designmenu_separators_form_size'),
          type: "number",
          required: true,
          defaultValue: 3,
          tooltip: t('designmenu_separators_form_size_tooltip'),
          inputProps: { min: 0, max: 100 },
          endAdornment: { value: "px" },
          size: "small"
        },
        {
          id: "separatorColor",
          name: t('designmenu_separators_form_color'),
          type: "gradient",
          required: true,
          defaultValue: "#000000",
          tooltip: t('designmenu_separators_form_color_tooltip'),
          size: "small"
        }
      ]
    }
  ]
}